<template>
    <div @click="$emit('click')" class="h-full px-3 flex items-center cursor-pointer border-0 border-r border-solid border-gray-700">
        <i :class="icon" class="ds-text-2xl text-white" />
    </div>
</template>

<script>
export default {
    props: {
        icon: { type: String, required: true },
    },   
}
</script>